// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__UqPts","layout__aside":"Layout_layout__aside__lvjFR"};